import { makeAutoObservable, runInAction } from 'mobx';
import type { RootStore } from './root-store';
import type { AffiliateStore } from './affiliate-store';
import { AffiliatePayoutPaginatedMobxDto } from '../mobx/dtos/affiliate/affiliate-payout-paginated-mobx-dto';

export class AffiliatePayoutStore {
    rootStore: RootStore;

    affiliateStore: AffiliateStore;

    loading = false;

    affiliatePayoutPaginated: AffiliatePayoutPaginatedMobxDto;

    constructor(affiliateStore: AffiliateStore) {
        this.rootStore = affiliateStore.rootStore;
        this.affiliateStore = affiliateStore;

        makeAutoObservable(this, {
            rootStore: false,
            affiliateStore: false,
        });
    }

    startLoading(): void {
        this.loading = true;
    }

    stopLoading(): void {
        this.loading = false;
    }

    async fetchAffiliatePayouts(affiliateId: string, limit?: number, offset?: number): Promise<void> {
        this.startLoading();
        try {
            const [affiliatePayoutPaginatedDto] = await Promise.all([
                this.rootStore.apiClient.affiliatePayoutController.affiliatePayoutControllerGet({
                    affiliateId,
                    limit,
                    offset,
                }),
            ]);

            runInAction(() => {
                this.affiliatePayoutPaginated = AffiliatePayoutPaginatedMobxDto.create(affiliatePayoutPaginatedDto);
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
            this.rootStore.alertStore.setErrorMessageByStatus(e.message);
        } finally {
            this.stopLoading();
        }
    }
}
